var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div dias-cloak=\"vm.loading\" class=\"list-group\"><div ng-repeat=\"feld in vm.parameter[vm.key].wert track by $index\" class=\"list-group-item\"><span><strong>{{ $index + 1 }}. {{ feld.bez }}</strong><span ng-if=\"feld.label !== feld.bez\">&nbsp; (Label: {{ feld.label }})</span><span ng-if=\"feld.omit_if_empty\">,&nbsp;Bei fehlendem Wert ausblenden</span><span ng-if=\"feld.empty_text\">,&nbsp;Standardwert: {{ feld.empty_text }}</span></span></div></div>");;return buf.join("");
}